// A testimonial page's meta description as the live site's theme makes it (page.tpl.php): the
// testimonial's text without its tags, the first 150 bytes and "..." when it is longer. Live cuts at
// the byte; this cuts between characters, as the backend's SharePreview::testimonialDescription(),
// which writes the same into the page's HTML.
const LIMIT = 150;

// A character's length in UTF-8, as PHP's strlen counts it
const utf8Length = (codePoint) => (codePoint < 0x80 ? 1 : codePoint < 0x800 ? 2 : codePoint < 0x10000 ? 3 : 4);

export const testimonialDescription = (body) => {
    const text = String(body || '').replace(/<[^>]*>/g, '');
    let bytes = 0;
    let kept = '';
    for (const char of text) {
        bytes += utf8Length(char.codePointAt(0));
        if (bytes > LIMIT) {
            // A character cut in two at the limit is left out
            return kept + '...';
        }
        kept += char;
    }
    return text;
};
